import { formatCurrency } from 'utils/currency';

export type InvoiceFieldKey = 'poAmount' | 'invoiceNumber';

export type InvoiceValidationError = {
  field: InvoiceFieldKey;
  message: string;
};

export type ValidateInvoiceInput = {
  poAmount: number | null;
  invoiceNumber: string | null;
};

const INVOICE_NUMBER_PATTERN = /^[A-Za-z0-9-]+$/;
const INVOICE_NUMBER_MAX_LENGTH = 50;

// Mirrors the DB column `decimal(12, 2)`: precision 12 / scale 2 →
// max storable value is 9_999_999_999.99. Sending above overflows
// Postgres and surfaces as a 500.
const PO_AMOUNT_MAX = 9_999_999_999.99;
const PO_AMOUNT_MAX_DISPLAY = formatCurrency(PO_AMOUNT_MAX);

export const validateInvoice = ({
  poAmount,
  invoiceNumber,
}: ValidateInvoiceInput): InvoiceValidationError[] => {
  const errors: InvoiceValidationError[] = [];

  if (poAmount !== null && poAmount < 0) {
    errors.push({
      field: 'poAmount',
      message: 'PO Amount must be greater than or equal to 0',
    });
  } else if (poAmount !== null && poAmount > PO_AMOUNT_MAX) {
    errors.push({
      field: 'poAmount',
      message: `PO Amount must not exceed ${PO_AMOUNT_MAX_DISPLAY}`,
    });
  }

  if (invoiceNumber !== null && invoiceNumber.length > 0) {
    if (invoiceNumber.length > INVOICE_NUMBER_MAX_LENGTH) {
      errors.push({
        field: 'invoiceNumber',
        message:
          'Number of characters exceeded (50), please verify and try again',
      });
    } else if (!INVOICE_NUMBER_PATTERN.test(invoiceNumber)) {
      errors.push({
        field: 'invoiceNumber',
        message: 'Invalid character, please verify and try again',
      });
    }
  }

  return errors;
};
